import React, { useEffect, useRef, useState } from 'react'
import './landing-content.styles.scss'
import { Navigate, useParams, useNavigate } from 'react-router-dom'
import Footer from '@/components/footer/footer.component'
import { doc, getDoc } from "firebase/firestore";
import { db } from '@/utils/firebase.utils'
import { useSelector } from 'react-redux';
import Header2025 from '../header-2025/header-2025.component'
import { ModalConfirm } from '../modal/modal.component'
import Loader from '../SHARED/loader/loader.comp';
import { getQueryFromFirestore, getUniqueDocumentFromFirestore } from '../../utils/getDataFromDbSimplified';

const LandingContent = () => {

	const navigate = useNavigate();
	const screenSize = useSelector(state => state.listsData.screenSize);
	const currentUser = useSelector(state => state.userData.currentUser);
	const profile = useSelector(state => state.userData.userProfile)
	const dbData = useSelector(state => state.userData.dbData)
	const { evalPath } = useParams()
	const [noId, setNoId] = useState(false)
	const [siteType, setSiteType] = useState(null);
	const [confirmMessage, setConfirmMessage] = useState(null);
	const approveRef = useRef();

	useEffect(() => {
		if (!evalPath) {
			setNoId(true);
			goToEvals();
			return;
		}
		localStorage.setItem('evalPath', evalPath)
		navigate(`/eval/${evalPath}`);
	}, [evalPath]);

	async function getEvalDoc() {
		getQueryFromFirestore({
			'path': `evaluations_v2`,
			'queryArray': [
				{
					'field': 'path',
					'operator': '==',
					'value': evalPath
				},
				{
					'field': 'status',
					'operator': '==',
					'value': 'active'
				}
			],
			'once': true,
			'callback': callback
		})
		function callback(data) {
			const evalDoc = Object.values(data)[0];
			if (!evalDoc) {
				console.log("No such document!");
				setConfirmMessage('The evaluation ID you have entered is not valid. Please check the link and try again. If you continue to have issues, please contact support at support@edleadersnetwork.org.');
				approveRef.current = () => {
					// navigate(`/`);
					return;
				};
				return;
			}
			localStorage.setItem('evalPath', evalPath)
			goToEvals();
		}
		// if (evalDoc) {

		// } else {
		// 	// doc.data() will be undefined in this case
		// 	setNoId(true);
		// 	console.log("No such document!");
		// 	setConfirmMessage('The evaluation ID you have entered is not valid. Please check the link and try again. If you continue to have issues, please contact support at support@edleadersnetwork.org.');
		// 	approveRef.current = () => {
		// 		navigate(`/`);
		// 	};
		// }
	}

	// useEffect(() => {
	// 	if (evalPath) {
	// 		let href = window.location.origin
	// 		let encoded = encodeURIComponent(href + '/sso/?token={token}&intendedurl=%2Fhome%2F')
	// 		console.log(encoded)
	// 		window.open('https://edleadersnetwork.org/login/?site=' + (href.includes('localhost') ? 'evaldev' : 'eval'), '_self');

	// 	}

	// }, [evalPath])

	function goToEvals() {
		if (currentUser && profile && dbData) {
			console.log('navigating to home');
			navigate(`/home`)
		} else {
			let href = window.location.origin
			let encoded = encodeURIComponent(href + '/sso/?token={token}&intendedurl=%2Fhome%2F')
			console.log(encoded)
			window.open('https://edleadersnetwork.org/login/?site=' + (href.includes('localhost') ? 'evaldev' : 'eval'), '_self');
			// let href = window.location.origin
			// // console.log(window.location)
			// let encoded = encodeURIComponent(href  + `/sso/?token={token}&intendedurl=%2Fhome%2F${e}`)
			// // console.log(encoded)
			// window.open(`https://eweb.ilprincipals.org/eweb/?Site=ipa&WebCode=LoginRequired&expires=yes&URL_success=${encoded}`, '_self')
		}

	}

	return (
		<div className={`landing-content ${screenSize}`}>
			<div className="index-header">
				{
					(noId)
						?
						<>
							<Header2025 />

							<div className={`main-content ${screenSize}`}>
								<Loader />
								{/* <div className='g-height-40'></div>
							<h3>Please make sure you are using the correct link to the evaluation.<br />Click one of the options below to see your completed evaluations.</h3>

							<div className='cards'>
								<button className='g-card source-card ipa'  onClick={() => goToEvals('ipa')}>
									<div className='source-card-icon-div'>
										<img src={ipa_logo} className='source-card-icon' />
									</div>
									<div className='source-card-text'>
										<h3>View My IPA Evaluations</h3>
									</div>
								</button>
								<button className='g-card source-card eln' onClick={() => goToEvals('eln')}>
									<div className='source-card-icon-div'>
										<img src={eln_logo_white} className='source-card-icon' />
									</div>
									<div className='source-card-text'>
										<h3>View My ELN Evaluations</h3>
									</div>
								</button>
							</div>
							<div className='g-height-40'></div> */}
							</div>

							<Footer />
						</>

						: ''
				}
			</div>
			<ModalConfirm
				show={confirmMessage}
				cancel={() => setConfirmMessage(null)}
				message={confirmMessage}
				onApprove={approveRef.current} />
		</div>
	)
}

export default LandingContent